import { defineStore } from 'pinia';
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';

export const useServiceErrorsStore = wrapPiniaStore(
  defineStore('serviceErrors', {
    state: () => ({
      commentsError: false,
      reactionsError: false,
    }),

    getters: {
      commentsServiceError(state): boolean {
        return state.commentsError;
      },

      reactionsServiceError(state): boolean {
        return state.reactionsError;
      },
    },

    actions: {
      setCommentsServiceError(isError: boolean) {
        this.commentsError = isError;
      },

      setReactionsServiceError(isError: boolean) {
        this.reactionsError = isError;
      },
    },
  }),
);
